import { useState } from 'react'

export default function useDebtsItemState() {
    const [modal, setModal] = useState(false);

    return {
        modal,
        updateModal: setModal
    }
}